import {
  CommonNetworkService,
  Helpers,
} from "@tpd-web-common-libs/nodejs-library";

class SEARCH_SEMANTICO_URL_CONSTANTS {
  static SUGGESTION_URL = "search/tpd/v1/suggestion";
  static SEARCH_URL = "search/tpd/v1/search";
}
export interface ISearchSemantico {
  input: string;
}

class SearchSemanticoService {
  private commonNetworkService: CommonNetworkService;

  constructor() {
    this.commonNetworkService = new CommonNetworkService();
  }

  /**
   * Recupera i risultati della ricerca
   * @param searchSemanticoSearchRequest
   */
  // public getRisultatiRicerca(searchSemanticoSearchRequest: any): Promise<any> {
  //   const body = JSON.stringify(searchSemanticoSearchRequest);
  //   //const headers = {};
  //   //const queryParams = {};
  //   const url = Helpers.LoginHelper.userLogged ? `/api/priv/${SEARCH_SEMANTICO_URL_CONSTANTS.SEARCH_URL}` : `/api/pub/${SEARCH_SEMANTICO_URL_CONSTANTS.SEARCH_URL}`;
  //
  //   return this.commonNetworkService.post(url, body);
  // }

  /**
   * Recupera i suggerimenti
   * @param searchSemanticoSuggestionRequest
   */
  public getSuggestions(searchSemanticoSuggestionRequest: ISearchSemantico): Promise<any> {
    const body = JSON.stringify(searchSemanticoSuggestionRequest);
    const url = Helpers.LoginHelper.userLogged ? `/api/priv/${SEARCH_SEMANTICO_URL_CONSTANTS.SUGGESTION_URL}` : `/api/pub/${SEARCH_SEMANTICO_URL_CONSTANTS.SUGGESTION_URL}`;
    return this.commonNetworkService.post<ISearchSemantico>(url, body);
  }

}

export default SearchSemanticoService;
